import React, { useReducer, useState } from "react";
import Header from "./component/Header/Header";
import Modal from "./component/UI/Modal";
import MessageComponent from "./component/Message/MessageComponent";
import ReactIcon from "./component/Icons/ReactIcon";

const reducerModal = function (prevState, action) {
  if (action.action === "instructions") {
    return {
      isModal: true,
      title: "Instructions",
      info: "This is a simple hello application. Click the rotating icon in the center to find a form. Enter your name and submit to find a key. Click on the key to unlock the chest to find your hidden message.",
    };
  }

  if (action.action === "creator") {
    return {
      isModal: true,
      title: "My Creator",
      info: "My name is Chandu Kathi and I am a second year in college, who recently switched my major to Computer Science. I am learning Reactjs and wanted to test my skills with this application.",
    };
  }

  if (action.action === "close") {
    return { isModal: false, title: "", info: "" };
  }
};

function App() {
  const [main, setMain] = useState(false);
  const [modalState, dispatchModal] = useReducer(reducerModal, {
    isModal: false,
    title: "",
    info: "",
  });

  const instructionHandler = function () {
    dispatchModal({ action: "instructions" });
  };

  const creatorHandler = function () {
    dispatchModal({ action: "creator" });
  };

  const closeHandler = function () {
    dispatchModal({ action: "close" });
  };

  const mainHandler = function () {
    setMain((prevState) => !prevState);
  };

  return (
    <React.Fragment>
      <Header onInstruction={instructionHandler} onCreator={creatorHandler} />
      {modalState.isModal && (
        <Modal
          title={modalState.title}
          info={modalState.info}
          onClose={closeHandler}
        />
      )}

      {main || <ReactIcon onClick={mainHandler} />}
      {main && <MessageComponent />}
    </React.Fragment>
  );
}

export default App;
